import { render, staticRenderFns } from "./ProblemPhotoGallery.vue?vue&type=template&id=1275d4c1&scoped=true"
import script from "./ProblemPhotoGallery.vue?vue&type=script&lang=js"
export * from "./ProblemPhotoGallery.vue?vue&type=script&lang=js"
import style0 from "./ProblemPhotoGallery.vue?vue&type=style&index=0&id=1275d4c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275d4c1",
  null
  
)

export default component.exports